import { yyyyMmDdSchema } from "@redotech/redo-model/common/zod-util";
import * as z from "zod/v4";

const CarrierCountSchema_ = z.object({
  /** Raw carrier name from Shopify fulfillment */
  rawCarrier: z.string(),
  /** Carrier after applying merchant mappings */
  resolvedCarrier: z.string().nullish(),
  count: z.number(),
});

export const CarrierCountSchema: z.ZodType<CarrierCount> = CarrierCountSchema_;

export interface CarrierCount extends z.infer<typeof CarrierCountSchema_> {}

export const GetTeamCarrierDistributionInputSchema = z.object({
  teamId: z.string(),
  startDate: yyyyMmDdSchema,
  endDate: yyyyMmDdSchema,
});

export const GetTeamCarrierDistributionOutputSchema = z.object({
  teamName: z.string(),
  carriers: z.array(CarrierCountSchema),
});

export type GetTeamCarrierDistributionInput = z.infer<
  typeof GetTeamCarrierDistributionInputSchema
>;
export type GetTeamCarrierDistributionOutput = z.infer<
  typeof GetTeamCarrierDistributionOutputSchema
>;

export const getTeamCarrierDistribution = {
  name: "getTeamCarrierDistribution" as const,
  input: GetTeamCarrierDistributionInputSchema,
  output: GetTeamCarrierDistributionOutputSchema,
};
